import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import NoRecordsComponent from './no-records-component';

const mapStateToProps = (state: ApplicationState) => ({
  t: state.i18n.t
});

export default connect(mapStateToProps, {})(NoRecordsComponent);
